import { render, staticRenderFns } from "./DomainesList.vue?vue&type=template&id=4659bc81&"
import script from "./DomainesList.vue?vue&type=script&lang=js&"
export * from "./DomainesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports